import React, { useState, useEffect, useContext } from 'react';
import { Redirect, useHistory,useParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import UserService from '../../services/UserService';
import UserContext from '../../contexts/UserContext';
import AuthService from '../../services/auth.services';
import FriendsService from '../../services/FriendService';
import GroupService from '../../services/GroupService';
import PostService from '../../services/PostService';
import ShareupInsideHeaderComponent from '../dashboard/ShareupInsideHeaderComponent';
import Layout from '../LayoutComponent';
import PostComponent from '../post/PostComponent';
import { testScript } from '../../js/script';
import MenuWidgetComponent from '../widgets/MenuWidgetComponent';
import settings from '../../services/Settings';
import fileStorage from '../../config/fileStorage';
import Grpicon from '../../images/grpicon.png'

function GroupComponent({post}) {
	const { id: stringId } = useParams();
	const groupid = 1 * stringId
	testScript()
	const history = useHistory();

	const { user } = useContext(UserContext)

	// const []
	const [refresh, setRefresh] = useState([]);
	const [members, setMembers] = useState([]);
	const [userInGroup, setUserInGroup] = useState(false);
	const [group, setGroup] = useState([]);
	const [allGroups, setAllGroups] = useState([]);


	const [searchedGroups, setSearchedGroups] = useState([]);

	const [myGroups, setMyGroups] = useState([]);
	const [searchedMyGroups, setSearchedMyGroups] = useState([]);

	const [showComp, setShowComp] = useState("allgroups");

	const getAllGroups = async () => {
		await GroupService.getAllGroups().then(res => {
			const data = Array.isArray(res.data) ? res.data : (res.data && Array.isArray(res.data.data) ? res.data.data : [])
			setAllGroups(data)
			setSearchedGroups(data)
		})
	}

	const getMyGroups = async () => {
		await GroupService.getGroupByCurrentUser(user.email).then(res => {
            const data = Array.isArray(res.data) ? res.data : (res.data && Array.isArray(res.data.data) ? res.data.data : [])
            const uniqueGroups = Array.from(new Set(data.map(a => a.id)))
        .map(id => {
          return data.find(a => a.id === id)
        })
            setMyGroups(uniqueGroups)
            setSearchedMyGroups(uniqueGroups)
        })
	}

	const handleSearchGroup = (event) => {
		if (event.target.value === "") {
			setSearchedGroups(allGroups)
		} else {
			const temp = []
			allGroups.map(u => {
				if (u.name.includes(event.target.value)) {
					temp.push(u)
				}
				
			})
			setSearchedGroups(temp)
		}
	}

	const handleSearchMyGroup = (event) => {
		if (event.target.value === "") {
			setSearchedMyGroups(myGroups)
		} else {
			const temp = []
			myGroups.map(u => {
				if (u.name.includes(event.target.value)) {
					temp.push(u)
				}
			})
			setSearchedMyGroups(temp)
		}
	}

	const handleShowComp = () => {
		if (showComp === "allgroups") {
			return showAllGroupsComponent()
		}
		else {
			return showMyGroupsComponent()
		}
	}
	const handleLeaveGroup = (e,group_id) => {
		e.preventDefault();
		GroupService.leaveGroup(user.id, group_id).then(res => {
			setRefresh(res.data)
			setGroup(res.data)
		})
	}

	const handleJoinGroup = (e,group_id) => {
		e.preventDefault();
		GroupService.joinGroup(user.id, group_id).then(res => {
			setRefresh(res.data)
			setGroup(res.data)
		})
	}

	const checkIfInGroup = (members) => {
		const found = members.some(el => el.id === user.id);
		return found
	}




	const showAllGroupsComponent = () => {
		return (
			
			<div className="tab-content">
					<div className="friends-search-container grp-search" >
							<input className="friend-search" type="text" id="header-search" placeholder="Search Groups" name="s" onChange={handleSearchGroup} style={{width:'100%',marginLeft:'0'}}/>
						</div>
				<div className="tab-pane active fade show " id="">
					<ul className="nearby-contct" style={{marginTop:'15px'}}>
						
						{searchedGroups.map((group) =>
								<li key={group.id} className="friends-card groupalign" >
		                            <a href={`/groups/${group.id}`}>

										<div className="group-li-item">
											{/* <figure> */}
											<div className="item12">
												<a href={`/groups/${group.id}`} title="#"> <img src={group.groupImagePath ? fileStorage.baseUrl+group.groupImagePath : Grpicon} alt="" className={group.groupImagePath ? "img" : "no-img"} /></a>
												{/* </figure> */}
												{/* <button className="preview-btn" onClick={() => handleJoinGroup(group.id)}>Preview</button>	 */}
											</div>
											{/* <div className="  "> */}
											<div className="item23">
												<p className="grpnametag" style={{ height: '20px', fontWeight: '600'}}><a href={`/groups/${group.id}`} title="#">{`${group.name}`}</a></p>
												<p className="grp-mem-text">2.7K Members</p>
												<div style={{width: '100%' , display: 'flex' , alignItems: 'center' , justifyContent: 'center'}}>
													{
															checkIfInGroup(group.members) ?
																<a href className="button grp-btn leave-grp-btn" onClick={(e) => handleLeaveGroup(e,group.id)}>Leave Group</a>
																:
																<a href className="button grp-btn join-grp-btn"  onClick={(e) => handleJoinGroup(e,group.id)}>Join Group</a>
														}
													{/* <div className="button" style={{ color: "#000000",background:'#EAEAEA', fontSize:'12px', width: '45%' , padding: '5px' , fontWeight: '600' }}>Preview</div>	 */}
												</div>
											</div>
											
											{/* <div className="item6">
												{/* <span>Engr</span> */}
												{/* <i style={{ float: "right", fontSize: 25 }} className="las la-ellipsis-v"></i> */}
											{/* </div> */}
											


											{/* </div> */}

										</div>
									</a>
								</li>
						)}
					</ul>
					<div className="lodmore"><button className="btn-view btn-load-more" /></div>
				</div>
			</div>
		)
	}

	const showMyGroupsComponent = () => {
		return (
			<div className="tab-content">
			<div className="friends-search-container grp-search" >
							<input className="friend-search" type="text" id="header-search" placeholder="Search Groups" name="s" onChange={handleSearchMyGroup} style={{width:'100%',marginLeft:'0'}}/>
						</div>
			<div className="tab-pane active fade show " id="">
				<ul className="nearby-contct" style={{marginTop:'15px'}}>
					
					{searchedMyGroups.map((group,index) =>
							<li key={group.id} className="friends-card groupalign" style={((index+1)/3==0)?{marginRight:'0px'}:{marginRight:'10px'}}>
								<a href={`/groups/${group.id}`}>


									<div className="group-li-item">
										{/* <figure> */}
										<div className="item12">
											<a href={`/groups/${group.id}`} title="#"> <img src={group.groupImagePath ? fileStorage.baseUrl+group.groupImagePath : Grpicon} alt="" className={group.groupImagePath ? "img" : "no-img"} /></a>
											{/* </figure> */}
											{/* <button className="preview-btn" onClick={() => handleJoinGroup(group.id)}>Preview</button>	 */}
										</div>
										{/* <div className="  "> */}
										<div className="item23">
											<p className="grpnametag" style={{ height: '20px', fontWeight: '600'}}><a href={`/groups/${group.id}`} title="#">{`${group.name}`}</a></p>
											<p className="grp-mem-text">2.7K Members</p>
											<div style={{width: '100%' , display: 'flex' , alignItems: 'center' , justifyContent: 'center'}}>
												{
														checkIfInGroup(group.members) ?
															<a href className="button grp-btn leave-grp-btn" onClick={(e) => handleLeaveGroup(e,group.id)}>Leave Group</a>
															:
															<a href className="button grp-btn join-grp-btn"  onClick={(e) => handleJoinGroup(e,group.id)}>Join Group</a>
													}
												{/* <div className="button" style={{ color: "#000000",background:'#EAEAEA', fontSize:'12px', width: '45%' , padding: '5px' , fontWeight: '600' }}>Preview</div>	 */}
											</div>

											
										</div>
										
										{/* <div className="item6">
											{/* <span>Engr</span> */}
											{/* <i style={{ float: "right", fontSize: 25 }} className="las la-ellipsis-v"></i> */}
										{/* </div> */}
										


										{/* </div> */}

									</div>
								</a>
							</li>
					)}
				</ul>
				<div className="lodmore"><button className="btn-view btn-load-more" /></div>
			</div>
		</div>
		)
	}

	useEffect(() => {
		getAllGroups()
		getMyGroups()
	}, [showComp, refresh])

	useEffect(() => {
		testScript()
	}, [])

	return (
		<Layout user={user}>
			<div className="">
				<div className="central-meta swap-pg-cont">
					<div className="frnds">
						<div>
							<p className="Friends-Title">Groups</p>
							<i style={{ float: "right", fontSize: 20 }} className="fas fa-ellipsis-v"></i>
						</div>
						
							
						</div>
						<div className="navContent">
							<ul className="nav nav-pills swap-page-nav " role="tablist">
								<li className="nav-item" style={{justifyContent:'flex-start'}}>
									<div className="all">
										<span style={{ cursor: 'pointer' }} onClick={() => setShowComp("allgroups")}>
											<span style={{  padding: '5px' }}> 
											<i className="las la-users" style={{fontSize:'20px'}}></i>
											{/* <span>{`${following.length}`}</span> */}
											</span>
										All Groups
										</span>
									</div>	
								</li> 
								<li className="nav-item" style={{justifyContent:'center'}}>
									<div className="my">
										<span style={{ cursor: 'pointer' }} onClick={() => setShowComp("mygroups")}>
											<span style={{  padding: '5px' }}> 
											<i className="las la-user-friends" style={{fontSize:'20px'}}></i>
											{/* <span>{`${following.length}`}</span> */}
											</span>
											My Groups 
										</span>
									</div>
								</li>
								<li className="nav-item" style={{justifyContent:'flex-end'}}>
									<div className="new">
										<span style={{ cursor: 'pointer' }} onClick={() => history.push('/group/create')}>
											<span style={{  padding: '5px' }}> 
											<i className="las la-user-friends" style={{fontSize:'20px'}}></i>
											{/* <span>{`${following.length}`}</span> */}
											</span>
											Create group
										</span>
									</div>
								</li>
							</ul>
												
						</div>
					
						{handleShowComp()}
					</div>
			</div>
		</Layout>
	);
}
export default GroupComponent;